import { getEnv } from '../../utils';

export default {
  data() {
    return {
      refreshing: false,
      registration: null,
      updateExists: false,
    };
  },
  created() {
    // Check for stored update state on startup
    // this.checkStoredUpdateState();

    // Listen for our custom event from the SW registration
    if (getEnv('NODE_ENV') === 'production') {
      document.addEventListener('swUpdated', this.updateAvailable, {
        once: true,
      });

      // Prevent multiple refreshes
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) return;
        this.refreshing = true;

        // Clear the update flag when actually updating
        // localStorage.removeItem('app_update_exists');

        // Here the actual reload of the page occurs
        window.location.reload();
      });
    }
  },
  methods: {
    // not in use for testing update beharviour:
    // https://gidt.atlassian.net/browse/GID-1934
    checkStoredUpdateState() {
      // Check if we have a stored update state
      const storedUpdateExists = localStorage.getItem('app_update_exists');
      if (storedUpdateExists === 'true') {
        this.updateExists = true;

        // Try to retrieve the registration if available
        navigator.serviceWorker.ready
          .then((registration) => {
            this.registration = registration;
          })
          .catch((err) => {
            console.error('Failed to get SW registration:', err);
          });
      }
    },
    updateAvailable(event) {
      this.registration = event.detail;
      this.updateExists = true;

      // Store the update state persistently
      // localStorage.setItem('app_update_exists', 'true');
    },
    refreshApp() {
      this.updateExists = false;

      // Clear the update flag
      // localStorage.removeItem('app_update_exists');

      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return;

      // Send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    },
  },
};
